<div class="jumbotron d-flex align-items-center m-4 ">
  <fa-icon [icon]="['fal','wifi-slash']" size="4x"></fa-icon>
  <div class="d-flex flex-column m-4">
    <h1 class="mb-4" i18n>Report cannot be displayed while offline</h1>
    <p i18n>This report can only be used when you have a network connection.  Please check that your device is online.</p>
    <p i18n>If the report or app should be available offline, check <a routerLink="/Softools.Applications/0">Application Settings</a> or contact your administrator.</p>
  </div>
</div>
